import { render } from "./BottomButtonsComponent.vue?vue&type=template&id=45e8bdb8&scoped=true"
import script from "./BottomButtonsComponent.vue?vue&type=script&lang=js"
export * from "./BottomButtonsComponent.vue?vue&type=script&lang=js"

import "./BottomButtonsComponent.vue?vue&type=style&index=0&id=45e8bdb8&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e8bdb8"]])

export default __exports__